import { render } from "./SelectedPVT.vue?vue&type=template&id=1e9ffa35"
import script from "./SelectedPVT.vue?vue&type=script&lang=js"
export * from "./SelectedPVT.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__